import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';
import * as CookieConsent from 'vanilla-cookieconsent';
import { CONSENT_CONFIG, CONSENT_CONFIG_DEFAULT, CONSENT_ENABLED } from './config';

export const  provideConsentBannerConfig = (enabled?: boolean, config?: Partial<CookieConsent.CookieConsentConfig>): EnvironmentProviders => {
  const providers = makeEnvironmentProviders([
    {
      provide: CONSENT_ENABLED,
      useValue: !!enabled,
    },
    {
      provide: CONSENT_CONFIG,
      useValue: config ?? CONSENT_CONFIG_DEFAULT,
    },
    
  ]);


  return providers;
};
